module.exports = __webpack_public_path__ + "static/media/wavm8s-020-glimji-hideout.b8f1013.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-020-glimji-hideout.mp3
// module id = Z0O3
// module chunks = 0